import {ComputedRef, InjectionKey} from "vue";
import {IField} from "~/cabinet/vue/interface/form/elements/Interfaces";

export const MY_FORM_CONSTRUCTOR_ALL_ELEMENTS_INJECT = Symbol() as InjectionKey<ComputedRef<(IField | null)[]>>;